"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var bronson_min_1 = __importDefault(require("@vwfs-bronson/bronson-bluelabel/dist/js/bronson.min"));
var SliderStage = /** @class */ (function () {
    function SliderStage(component) {
        this.component = component;
        this.numberOfItemsToDisplay = 0;
        this.totalNumberOfSlides = 0;
        if ('sliderNumberOfItemsToDisplay' in component.dataset) {
            this.numberOfItemsToDisplay = parseInt(component.dataset.sliderNumberOfItemsToDisplay);
        }
        if ('sliderTotalNumberOfSlider' in component.dataset) {
            this.totalNumberOfSlides = parseInt(component.dataset.sliderTotalNumberOfSlider);
        }
        // CHECK NUMBER-OF-ITEMS-TO-DISPLAY
        if (!this.numberOfItemsToDisplay) {
            console.debug('SliderStage: numberOfItemsToDisplay is null.');
            return;
        }
        if (this.totalNumberOfSlides > 1 && this.numberOfItemsToDisplay > 0) {
            // TAKE THE LOWEST COUNT
            this.numberOfItemsToDisplay = Math.min(this.totalNumberOfSlides, this.numberOfItemsToDisplay);
            // GET THE RANDOMIZED SLIDES TO BE DISPLAYED
            var listOfSlidesIDsToBeDisplayed = this.getRandomizedSlidesIDs();
            // CHECK LIST-OF-SLIDES-TO-BE-DISPLAYED
            if (!listOfSlidesIDsToBeDisplayed) {
                console.debug('SliderStage: listOfSlidesIDsToBeDisplayed is null.');
                return;
            }
            // CHANGE THE DOM WITH NEW ITEMS
            this.updateStageSliderMarkupWithSlidesToBeDisplayed(listOfSlidesIDsToBeDisplayed);
            if (this.numberOfItemsToDisplay > 1) {
                // ADD CLASS
                this.component.classList.add('js-hero-slider');
                // INIT BRONSON HERO-SLIDER
                bronson_min_1.default.HeroSlider.init(); // eslint-disable-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
            }
        }
    }
    /**
     * GET RANDOMIZED SLIDE IDs
     * Get List of randomized slidesIDs from slider.
     */
    SliderStage.prototype.getRandomizedSlidesIDs = function () {
        var _this = this;
        var listOfStageSlidesIDs = [];
        var listOfStageSlides = [];
        var weights = [];
        // ITERATE EXISTING SLIDER ITEMS
        this.component.querySelectorAll('.c-hero-slider__item').forEach(function (stageSliderItem) {
            // GET ATTRIBUTES FROM ELEMENT
            var weight;
            if ('priority' in stageSliderItem.dataset) {
                weight = parseInt(stageSliderItem.dataset.priority);
            }
            var stageSliderItemID = stageSliderItem.id;
            if (weight > 0 && stageSliderItemID) {
                // ADD SLIDE AND WEIGHT TO LIST
                listOfStageSlidesIDs.push(stageSliderItemID);
                weights.push(weight);
                var item = { id: stageSliderItemID, weight: weight };
                listOfStageSlides.push(item);
            }
        });
        if (listOfStageSlidesIDs.length === this.totalNumberOfSlides) {
            var sortedStages = listOfStageSlides.sort(function (a, b) { return (a.weight > b.weight ? -1 : 1); });
            var weightedSortedStages = this.generateWeighedSortedStages(sortedStages);
            var listOfSlidesIDsToBeDisplayed_1 = [];
            var shuffledArray = this.shuffle(weightedSortedStages);
            // pick 'this.numberOfItemsToDisplay' items from 'weighedListOfSliderIDs'
            // and ignore duplicates
            var n_1 = 0;
            shuffledArray.forEach(function (sliderID) {
                if (listOfSlidesIDsToBeDisplayed_1.indexOf(sliderID) < 0 && n_1 < _this.numberOfItemsToDisplay) {
                    listOfSlidesIDsToBeDisplayed_1.push(sliderID);
                    n_1++;
                }
            });
            return listOfSlidesIDsToBeDisplayed_1;
        }
        return null;
    };
    SliderStage.prototype.shuffle = function (array) {
        var _a;
        for (var i = array.length - 1; i > 0; i--) {
            var j = Math.floor(Math.random() * (i + 1));
            _a = [array[j], array[i]], array[i] = _a[0], array[j] = _a[1];
        }
        return array;
    };
    /**
     * GENERATE WEIGHTED sorted LIST
     * Function for generating a weighted list with priorities from slider
     *
     * @param sortedStages
     * @returns {array}
     */
    SliderStage.prototype.generateWeighedSortedStages = function (sortedStages) {
        var weighedSortedStages = [];
        sortedStages.forEach(function (item) {
            for (var j = 0; j < item.weight; j++) {
                weighedSortedStages.push(item.id);
            }
        });
        return weighedSortedStages;
    };
    /**
     * UPDATE STAGE-SLIDER MARKUP WITH SLIDES TO BE DISPLAYED
     * This function modifies the DOM (replaces old slides with new) with the provided list of slides
     *
     * @param listOfSlidesIDsToBeDisplayed
     */
    SliderStage.prototype.updateStageSliderMarkupWithSlidesToBeDisplayed = function (listOfSlidesIDsToBeDisplayed) {
        // CREATE NEW INNER-HTML
        var updateHtmlString = '';
        listOfSlidesIDsToBeDisplayed.forEach(function (slideID) {
            updateHtmlString += document.getElementById(slideID).outerHTML;
        });
        // REPLACE INNER-HTML
        this.component.innerHTML = updateHtmlString;
        // REMOVE CLASS
        this.component.classList.remove(SliderStage.SLIDER_STAGE_RANDOMIZED_CLASS);
    };
    SliderStage.SLIDER_STAGE_RANDOMIZED_CLASS = 'c-hero-slider-randomize';
    return SliderStage;
}());
exports.default = SliderStage;
/**
 * ON DOCUMENT LOADED
 */
document.addEventListener('DOMContentLoaded', function () {
    console.debug('INFO SliderStage loaded');
    // FIND THE STAGE-SLIDER-RANDOMIZED (ONLY ONE COULD EXIST)
    var sliderEl = document.querySelector('.' + SliderStage.SLIDER_STAGE_RANDOMIZED_CLASS);
    if (sliderEl) {
        try {
            new SliderStage(sliderEl);
        }
        catch (e) {
            console.error('An error while creating a new SliderStage instance: {}', e);
        }
    }
    else {
        console.debug('DEBUG SliderStage: No stageslider found.');
    }
});
